// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicationUpdate
 */
export interface PublicationUpdate {
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  publishedVersion?: number | null;
}

/**
 * Check if a given object implements the PublicationUpdate interface.
 */
export function instanceOfPublicationUpdate(value: object): value is PublicationUpdate {
  return true;
}

export function PublicationUpdateFromJSON(json: any): PublicationUpdate {
  return PublicationUpdateFromJSONTyped(json, false);
}

export function PublicationUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationUpdate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    publishedVersion:
      json["published_version"] === undefined
        ? undefined
        : json["published_version"] === null
        ? null
        : json["published_version"],
  };
}

export function PublicationUpdateToJSON(json: any): PublicationUpdate {
  return PublicationUpdateToJSONTyped(json, false);
}

export function PublicationUpdateToJSONTyped(
  value?: PublicationUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    description: value["description"],
    published_version: value["publishedVersion"],
  };
}
